(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yotpo-faq"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const tabButtons = document.querySelectorAll('.faqs-tab-btn');
  const tabContents = document.querySelectorAll('.faqs-tab-content');
  const defaultTab = 'transition';

  // Show default tab on load
  tabButtons.forEach(button => {
    if (button.dataset.tab === defaultTab) {
      button.classList.add('active');
      button.setAttribute('aria-selected', 'true');
    } else {
      button.setAttribute('aria-selected', 'false');
    }
  });

  tabContents.forEach(content => {
    if (content.id === `tab-content-${defaultTab}`) {
      content.removeAttribute('hidden');
    } else {
      content.setAttribute('hidden', '');
    }
  });

  // Tab switching + auto-scroll into view
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      // Deactivate all tabs
      tabButtons.forEach(btn => {
        btn.classList.remove('active');
        btn.setAttribute('aria-selected', 'false');
      });

      // Hide all tab contents
      tabContents.forEach(content => content.setAttribute('hidden', ''));

      // Activate clicked tab
      const targetContent = document.getElementById(`tab-content-${button.dataset.tab}`);
      button.classList.add('active');
      button.setAttribute('aria-selected', 'true');
      if (targetContent) targetContent.removeAttribute('hidden');

      // Smooth scroll the clicked tab button into view
      button.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    });
  });

  // Accordion logic
  document.querySelectorAll('.faqs-accordion-item').forEach(item => {
    const title = item.querySelector('.faqs-accordion-title');
    title.addEventListener('click', () => {
      const parent = item.closest('.faqs-tab-content');
      parent.querySelectorAll('.faqs-accordion-item').forEach(other => {
        if (other !== item && other.classList.contains('active')) {
          other.classList.remove('active');
          other.querySelector('.faqs-accordion-content').style.maxHeight = '0';
        }
      });

      item.classList.toggle('active');
      const content = item.querySelector('.faqs-accordion-content');
      content.style.maxHeight = item.classList.contains('active') ? content.scrollHeight + 'px' : '0';
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
